import { useCallback } from "react";
import { POLICIES_POLICY_VALUE_DOWNLOAD } from "../../../constants/policies";
import useCanPerform from "../../../hooks/useCanPerform";
import useDownloadFile from "../../../hooks/useDownloadFile";
import generateApiUri from "../../../libraries/utils/generateApiUri";

/**
 * @typedef {Object} Props
 * @property {import("../../../types/CustomerDocument").CustomerDocument} [customerDocument]
 * @property {(props: { isAllowed: boolean, trigger: () => void, isLoading: boolean }) => import("react").ReactElement | null} render
 *
 * @param {Props} props
 */
function CustomersDocumentsActionDownload({ customerDocument, render }) {
  const canPerform = useCanPerform();

  const { download, isLoading } = useDownloadFile({
    mode: "preview",
  });

  const trigger = useCallback(() => {
    if (customerDocument) {
      download(
        generateApiUri({
          id: "@customers.documents.download",
          parameters: {
            documentId: customerDocument.id,
          },
        }),
      );
    }
  }, [customerDocument, download]);

  return (
    <>
      {customerDocument &&
        render({
          isAllowed:
            customerDocument !== undefined &&
            canPerform({
              policies: POLICIES_POLICY_VALUE_DOWNLOAD,
              resourcePolicies: customerDocument?.meta?.policies,
            }),
          trigger,
          isLoading,
        })}
    </>
  );
}

export default CustomersDocumentsActionDownload;
